import { useState } from 'react';
import { submitFormToSupabase } from '../services/formService';

type FormStatus = 'idle' | 'submitting' | 'success' | 'error';

export const useFormSubmit = <T extends Record<string, any>>(
  initialState: T,
  formName: string 
) => {
  const [formData, setFormData] = useState<T>(initialState);
  const [status, setStatus] = useState<FormStatus>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    
    const result = await submitFormToSupabase({
      formName,
      ...formData,
    });

    if (result.success) {
      setStatus('success');
      setFormData(initialState);
    } else {
      setStatus('error');
    }
  };

  return {
    formData,
    handleInputChange,
    handleSubmit,
    status,
    isSubmitting: status === 'submitting',
  };
};